import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import TabelaRelatorioGeral from '../Components/TabelaRelatorioGeral/tabelaRelatorioGeral';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import filtrarUsuarioIA from '../../FuncoesGerais/filtrarUsuarioIA';
import { ensureProtocol } from '../../config/backend';
import { getDatasPadrao } from '../../utils/relatorioDatas';
import { fetchStatusChamado } from '../../api/statusChamado';

import './relatorioGeral.css';

const CORES_GRAFICO = { emAndamento: '#6366f1', concluida: '#10b981' };

function RelatorioGeral() {

    const { datInic: defaultIni, datFina: defaultFim } = getDatasPadrao();
    const [data, setData] = useState([]);
    const [colunasStatus, setColunasStatus] = useState([]);
    const [datInic, setDatIni] = useState(defaultIni);
    const [datFina, setdatFin] = useState(defaultFim);
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState('');
    const [equipeVisualizacao, setEquipeVisualizacao] = useState({ equipe_ids: null, usuarios: [] });
    const [equipeSelecionada, setEquipeSelecionada] = useState('');
    const areaImpressaoRef = useRef(null);

    const history = useHistory();

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    function aplicarMascaraData(valor) {
        if (!valor) return '';

        const numeros = valor.replace(/\D/g, '').slice(0, 8);

        if (numeros.length <= 2) return numeros;
        if (numeros.length <= 4) return `${numeros.slice(0, 2)}/${numeros.slice(2)}`;
        return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4)}`;
    }

    const carregarEquipeVisualizacao = async () => {
        const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2') || '');
        const token = localStorage.getItem('token');
        if (!baseUrl || !token) {
            setEquipeVisualizacao({ equipe_ids: '', usuarios: [] });
            return;
        }
        try {
            const res = await axios.get(baseUrl + '/usuarios/equipe-visualizacao', { headers: { Authorization: token } });
            const d = res.data || {};
            const usuarios = filtrarUsuarioIA(Array.isArray(d.usuarios) ? d.usuarios : [], 'nome');
            setEquipeVisualizacao({
                equipe_ids: d.equipe_ids != null ? d.equipe_ids : '',
                usuarios
            });
        } catch (e) {
            console.error('Erro ao carregar equipe de visualização:', e);
            setEquipeVisualizacao({ equipe_ids: '', usuarios: [] });
        }
    };

    const imprimir = () => {
        const labelEquipe = equipeSelecionada ? (equipeVisualizacao.usuarios.find((u) => String(u.id || u.ID) === String(equipeSelecionada))?.nome || `Equipe ${equipeSelecionada}`) : 'Todos da minha equipe';
        const dataGeracao = new Date().toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
        if (areaImpressaoRef.current) {
            const janela = window.open('', '_blank');
            janela.document.write(`
                <html><head><title>Relatório Gerencial Total</title>
                <style>
                    body{ font-family: 'Segoe UI', system-ui, sans-serif; padding: 20px; color: #1e293b; }
                    table{ border-collapse: collapse; width:100%; margin-top:12px; }
                    th,td{ border:1px solid #e2e8f0; padding:10px 12px; text-align:left; }
                    th{ background:#f1f5f9; font-weight:600; color:#334155; }
                    tr:nth-child(even){ background:#f8fafc; }
                    .relatorio-rodape{ margin-top:24px; padding-top:12px; border-top:1px solid #e2e8f0; font-size:12px; color:#64748b; }
                    h1{ margin-bottom:8px; font-size:1.5rem; color:#0f172a; }
                    .periodo{ margin-bottom:16px; color:#475569; }
                </style></head><body>
                <h1>Relatório Gerencial Total</h1>
                <p class="periodo">Período: ${datInic} a ${datFina} &nbsp;|&nbsp; Filtro: ${labelEquipe}</p>
                ${areaImpressaoRef.current.innerHTML}
                <div class="relatorio-rodape">Emitido em ${dataGeracao}. Chamados pela data de abertura no período, filtrados pela equipe.</div>
                </body></html>`);
            janela.document.close();
            janela.focus();
            setTimeout(() => { janela.print(); janela.close(); }, 300);
        } else window.print();
    };

    const buscarRelatorio = async () => {

        verificar();

        const datIni = (datInic || '').trim();
        const datFin = (datFina || '').trim();
        const rawEquipe = equipeSelecionada !== '' ? equipeSelecionada : (equipeVisualizacao.equipe_ids != null && equipeVisualizacao.equipe_ids !== undefined ? equipeVisualizacao.equipe_ids : (localStorage.getItem('equpe') || localStorage.getItem('equipe') || ''));
        const equipe = (rawEquipe == null || rawEquipe === undefined || String(rawEquipe).trim() === '' || String(rawEquipe) === 'undefined') ? '' : String(rawEquipe).trim();

        if (!datIni || !datFin) {
            setErro('Informe a data inicial e a data final para pesquisar.');
            return;
        }
        setErro('');

        const datIniFull = datIni + ' 00:00:00';
        const datFinFull = datFin + ' 23:59:59';

        let listaRelatorioGeral = [];

        verificandoToken();
        setLoading(true);

        try {

            const token = localStorage.getItem('token');

            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/relatorioGeral", {
                headers: {
                    Authorization: `${token}`
                },
                params: {
                    datIni: datIniFull,
                    datFin: datFinFull,
                    equipe: equipe
                }
            });

            const raw = response.data || {};
            const rows = Array.isArray(raw.rows) ? raw.rows : (Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []));
            const statusCadastro = await fetchStatusChamado(false);
            const colunasFromCadastro = (statusCadastro || []).map((s) => ({ codigo_legado: s.codigo_legado, nome: s.nome || String(s.codigo_legado) }));
            const colunas = (raw.colunasStatus && raw.colunasStatus.length > 0) ? raw.colunasStatus : colunasFromCadastro;
            const toKey = (cod) => 'S_' + String(cod ?? '').replace(/\W/g, '_');

            for (let i = 0; i < rows.length; i++) {
                const r = rows[i];
                const item = { id: r.ID ?? r.id, dia: r.DIA ?? r.dia ?? '', fechadas: r.FECHADAS ?? r.fechadas ?? 0 };
                colunas.forEach((st) => { item[toKey(st.codigo_legado)] = r[toKey(st.codigo_legado)] ?? 0; });
                listaRelatorioGeral.push(item);
            }
            setColunasStatus(colunas);
            setData(listaRelatorioGeral);
        } catch (error) {
            setColunasStatus([]);
            setData([]);
            setErro(error?.response?.data?.error || 'Erro ao buscar dados.');
            console.error('Erro ao buscar dados:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        verificar();
        carregarEquipeVisualizacao();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (equipeVisualizacao.equipe_ids !== null) {
            buscarRelatorio();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [equipeVisualizacao.equipe_ids, equipeSelecionada]);

    const toKey = (cod) => 'S_' + String(cod ?? '').replace(/\W/g, '_');
    const chartData = data.map((r) => {
        let emAndamento = 0;
        colunasStatus.forEach((st) => { emAndamento += r[toKey(st.codigo_legado)] ?? 0; });
        return {
            name: r.dia || '—',
            Concluída: r.fechadas ?? 0,
            'Em andamento': emAndamento,
            total: (r.fechadas ?? 0) + emAndamento
        };
    });

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo relatorio-gerencial">
                <div className="relatorio-gerencial-topo no-print">
                    <h1 className="relatorio-gerencial-titulo">Relatório Gerencial Total</h1>
                    <div className="relatorio-gerencial-barra">
                        <div className="relatorio-gerencial-campos">
                            <label className="relatorio-gerencial-label">Data inicial</label>
                            <input value={datInic} onChange={(e) => setDatIni(aplicarMascaraData(e.target.value.toUpperCase()))} type="text" className="form-control relatorio-gerencial-input" placeholder="dd/mm/aaaa" aria-label="Data inicial" />
                        </div>
                        <div className="relatorio-gerencial-campos">
                            <label className="relatorio-gerencial-label">Data final</label>
                            <input value={datFina} onChange={(e) => setdatFin(aplicarMascaraData(e.target.value.toUpperCase()))} type="text" className="form-control relatorio-gerencial-input" placeholder="dd/mm/aaaa" aria-label="Data final" />
                        </div>
                        <div className="relatorio-gerencial-campos">
                            <label className="relatorio-gerencial-label">Equipe</label>
                            <select
                                value={equipeSelecionada}
                                onChange={(e) => setEquipeSelecionada(e.target.value)}
                                className="form-control form-control-sm relatorio-gerencial-equipe"
                                title="Filtrar por equipe"
                                aria-label="Filtrar por equipe"
                            >
                                <option value="">Todos da minha equipe</option>
                                {(equipeVisualizacao.usuarios || []).map((u) => (
                                    <option key={u.id ?? u.ID ?? u.login} value={u.id ?? u.ID ?? u.login}>{u.nome ?? u.login ?? u.NOME ?? '—'}</option>
                                ))}
                            </select>
                        </div>
                        <div className="relatorio-gerencial-botoes">
                            <button onClick={buscarRelatorio} className="btn btn-primary relatorio-gerencial-btn" type="button" disabled={loading}><i className="fas fa-search" aria-hidden /> {loading ? 'Carregando...' : 'Pesquisar'}</button>
                            <button type="button" className="btn btn-outline-primary relatorio-gerencial-btn" onClick={imprimir} title="Imprimir" disabled={data.length === 0}><i className="fas fa-print" aria-hidden /> Imprimir</button>
                        </div>
                    </div>
                </div>
                {erro && <div className="alert alert-warning no-print" role="alert">{erro}</div>}
                {loading && data.length === 0 && <p className="relatorio-gerencial-msg no-print">Carregando relatório...</p>}
                {!loading && data.length === 0 && !erro && <p className="relatorio-gerencial-msg no-print">Informe o período e clique em <strong>Pesquisar</strong> ou aguarde o carregamento automático.</p>}
                {data.length > 0 && (
                    <>
                        <div className="relatorio-grafico no-print">
                            <ResponsiveContainer width="100%" height={320}>
                                <BarChart data={chartData} margin={{ top: 16, right: 16, left: 8, bottom: 72 }}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                                    <XAxis dataKey="name" angle={-22} textAnchor="end" height={88} interval={0} tick={{ fontSize: 11, fill: '#334155', fontFamily: 'inherit' }} />
                                    <YAxis tick={{ fontSize: 11, fill: '#64748b' }} />
                                    <Tooltip
                                        contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
                                        labelStyle={{ color: '#334155', fontWeight: 600 }}
                                        formatter={(value) => [value, '']}
                                        labelFormatter={(label) => `Data: ${label}`}
                                    />
                                    <Legend wrapperStyle={{ paddingTop: 8 }} iconType="square" iconSize={10} formatter={(value) => <span style={{ color: '#475569' }}>{value}</span>} />
                                    <Bar dataKey="Em andamento" stackId="a" fill={CORES_GRAFICO.emAndamento} radius={[0, 0, 0, 0]} name="Em andamento" />
                                    <Bar dataKey="Concluída" stackId="a" fill={CORES_GRAFICO.concluida} radius={[0, 4, 4, 0]} name="Concluída" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div className="lista-wrapper" ref={areaImpressaoRef}>
                            <TabelaRelatorioGeral arrayRelatorioGeral={data} colunasStatus={colunasStatus} />
                        </div>
                        <div className="relatorio-rodape no-print">
                            Chamados considerados pela <strong>data de abertura</strong> no período {datInic} a {datFina}
                            {equipeSelecionada ? (<> &nbsp;·&nbsp; Filtro: <strong>{equipeVisualizacao.usuarios?.find((u) => String(u.id || u.ID) === String(equipeSelecionada))?.nome || equipeSelecionada}</strong></>) : ' · Todos da minha equipe'}.
                            &nbsp;Emitido em {new Date().toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })}.
                        </div>
                    </>
                )}
            </div>
            </main>
        </div>
    );
}

export default RelatorioGeral;
